"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useSliding = function (width, countElements) {
    var containerRef = (0, react_1.useRef)(null);
    var _a = (0, react_1.useState)(0), distance = _a[0], setDistance = _a[1];
    var _b = (0, react_1.useState)(0), totalInViewport = _b[0], setTotalInViewport = _b[1];
    var _c = (0, react_1.useState)(0), viewed = _c[0], setViewed = _c[1];
    var _d = (0, react_1.useState)(0), elementWidth = _d[0], setElementWidth = _d[1];
    (0, react_1.useEffect)(function () {
        if (width > 0) {
            var containerWidth = containerRef.current.clientWidth;
            setElementWidth(Math.floor(width / countElements));
            var totalInViewport_1 = Math.floor(containerWidth / Math.floor(width / countElements));
            setTotalInViewport(totalInViewport_1);
            if (countElements <= totalInViewport_1) {
                setDistance(0);
            }
        }
    }, [
        containerRef.current,
        containerRef.current && containerRef.current.clientWidth
    ]);
    var handlePrev = function () {
        setViewed(viewed - 1);
        setDistance(distance + elementWidth);
    };
    var handleNext = function () {
        setViewed(viewed + 1);
        setDistance(distance - elementWidth);
    };
    var slideProps = {
        style: { transform: "translate3d(".concat(distance, "px, 0, 0)") }
    };
    var hasPrev = distance < 0;
    var hasNext = viewed + totalInViewport < countElements;
    return { handlePrev: handlePrev, handleNext: handleNext, slideProps: slideProps, containerRef: containerRef, hasPrev: hasPrev, hasNext: hasNext };
};
exports.default = useSliding;
